import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AddWebContent from './Pages/AddWebContent/AddWebContent';
import EditWebContent from './Pages/EditWebContent/EditWebContent';

const WebContent = () => {
	const { path } = useRouteMatch();

	return (
		<>
			<React.Suspense fallback={<div>loading</div>}>
				<Switch>
					<Route path={`${path}`} exact>
						<AddWebContent />
					</Route>
					<Route path={`${path}/:id`} exact>
						<EditWebContent />
					</Route>
				</Switch>
			</React.Suspense>
		</>
	);
};

export default WebContent;
